export const MAIL_SETTING_FROM_EMAIL = "from_email"
export const MAIL_SETTING_OWNER_EMAIL = "owner_email"
export const MAIL_SETTING_DEVELOPER_EMAIL = "developer_email"

export const MAIL_TEMPLATE_CONFIRM_EMAIL = "confirm_email"
export const MAIL_TEMPLATE_USER_REGISTERED_NOTIFICATION = "user_registered_notification"
export const MAIL_TEMPLATE_RESET_PASSWORD = "reset_password"
